import qs from 'qs'
import { Http } from './http.init'
import { ErrorWrapper, ResponseWrapper } from './utils'
import axios from 'axios'
import { API_URL, resolveApiUrl } from '../env'
import { AuthService } from './auth.service'

export class BaseService {
  static get entity () {
    throw new Error('"entity" getter not defined')
  }

  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  static request (status = { auth: false }) {
    return new Http(status)
  }

  static responseWrapper (...rest) {
    return new ResponseWrapper(...rest)
  }

  static errorWrapper (...rest) {
    return new ErrorWrapper(...rest)
  }

  static querystring (obj) {
    return qs.stringify(obj, {
      encode: false
    })
  }

  /** Public GET; optional auth for like_by_me. Stale tokens must not break the feed. */
  static getPublicJson (url, { resolveUrl = false } = {}) {
    const requestUrl = resolveUrl ? resolveApiUrl(url) : url
    const authConfig = AuthService.axiosAuthConfig()
    const withAuth = () => axios.get(requestUrl, authConfig)
    const withoutAuth = () => axios.get(requestUrl)

    const attempt = authConfig ? withAuth() : withoutAuth()

    return attempt
      .then(response => new ResponseWrapper(response, response.data, ''))
      .catch(error => {
        if (authConfig && error.response && error.response.status === 401) {
          AuthService.clearAuthToken()
          return withoutAuth().then(
            response => new ResponseWrapper(response, response.data, '')
          )
        }
        return Promise.reject(new ErrorWrapper(error))
      })
  }
  /**
   * ------------------------------
   * @API_CALLS_PUBLIC
   * ------------------------------
   */

  static getListPublic (parameters = {}) {
    const params = {
      ...parameters
    }
    return new Promise((resolve, reject) => {
      return this.request().get(`${this.entity}`, { params })
        .then(response => {
          const data = {
            content: response.data.data.results,
            total: response.data.data.total
          }
          resolve(this.responseWrapper(response, data))
        }).catch(error => {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getByIdPublic (id = window.required()) {
    return new Promise((resolve, reject) => {
      return this.request().get(`${this.entity}/${id}`)
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  /**
   * ------------------------------
   * @API_CALLS_PRIVATE
   * ------------------------------
   */

  static like (id) {
    const url = `${API_URL}/dictionary_entry/like/${id}/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.put(url, {}, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }

  static dislike (id) {
    const url = `${API_URL}/dictionary_entry/dislike/${id}/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.put(url, {}, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }

  static flag (id) {
    const url = `${API_URL}/dictionary_entry/flag/${id}/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.put(url, {}, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }

  static getById (id) {
    const url = `${API_URL}/api/${this.entity}/${id}/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.get(url, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }

  static getDictionaryEntryById (id) {
    const url = `${API_URL}/api/dictionary_entry_list/${id}/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.get(url, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }

  static getPaginatedData (apiUrl) {
    return this.getPublicJson(apiUrl, { resolveUrl: true })
  }

  static getListViewData (_searchKeyword, filterBy, ordering) {
    let url = ''
    if (_searchKeyword) {
      url = `${API_URL}/api/${this.entity}/?search=${_searchKeyword}&user=${filterBy}&order=${ordering}`
    } else {
      url = `${API_URL}/api/${this.entity}/?user=${filterBy}&order=${ordering}`
    }
    return this.getPublicJson(url)
  }

  static create (data) {
    const url = `${API_URL}/api/${this.entity}/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.post(url, data, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }

  static update (data, id) {
    const url = `${API_URL}/api/${this.entity}/${id}/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.put(url, data, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }

  static remove (data, id) {
    const url = `${API_URL}/api/${this.entity}/${id}/`
    const headersConfig = this.request().request
    return new Promise((resolve, reject) => {
      axios.put(url, data, headersConfig)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => {
          reject(new ErrorWrapper(error))
        })
    })
  }
}
